<mat-card class="cardWithShadow">
  <mat-card-content>

    <div class="print-header">
      @if(hospitalInfo.logo){
      <img class="rounded-circle" [src]="staticimagepath+ hospitalInfo.logo" width="60"
        fallbackImage="assets/images/svgs/hospital.png" />
      }@else {
      <img class="rounded-circle" [src]="'assets/images/svgs/hospital.png'" width="60" />
      }
      <h2>{{ 'LABEL.BILL_CUM_RECEIPT' |translate}}</h2>
    </div>

    <div class="print-content">
      <div class="print-line">
        <span><strong>{{ 'LABEL.BILL_NO' |translate}}:</strong> {{successResult?.billNo||billData?.billNo}} </span>
        <span><strong>{{ 'LABEL.BILL_DATE' |translate}}:</strong> {{ successResult?.billDate|| billData?.billDate|date
          }} </span>
      </div>
      <div class="print-line">
        @if(isIPDBill){
        <span><strong>{{ 'LABEL.IPD_NO' |translate}}:</strong> {{billData?.ipdNumber}} </span>
        <span><strong>{{ 'LABEL.IPD_DATE' |translate}}:</strong> {{ billData?.admissionDate|date }} </span>
        }@else {
        <span><strong>{{ 'LABEL.OPD_NO' |translate}}:</strong> {{billData?.opdNumber}} </span>
        <span><strong>{{ 'LABEL.OPD_DATE' |translate}}:</strong> {{ billData?.opdDate|date }} </span>
        }
      </div>

      <div class="mb-2">
        <p><strong>{{ 'LABEL.RECEIVED_AMOUNT' |translate}}:</strong> {{ billData?.patientName }}</p>
        <p>
          <strong>{{ 'LABEL.SUM_OF_MONEY'|translate}}:</strong>
          ₹{{ billData?.grandTotal }} ({{ successResult?.amountInWords||billData?.amountInWords }})
        </p>
      </div>
      <hr>

      <div class="print-table-wrapper" *ngIf="!isIPDBill">
        <table class="table table-bordered table-striped m-0">
          <thead>
            <tr>
              <th class="text-left">{{ 'LABEL.NO' |translate}}.</th>
              <th class="text-left">{{ 'LABEL.CHARGE_LABEL' |translate}}</th>
              <th class="text-left">{{ 'LABEL.QTY' |translate}}</th>
              <th class="text-right">{{ 'LABEL.RATE' |translate}}</th>
              <th class="text-right">{{ 'LABEL.AMOUNT' |translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of billData?.billDetails; let i = index">
              <td>{{ i + 1 }}</td>
              <td class="text-left">{{ element.chargeName }}</td>
              <td class="text-left">{{ element.quantity }}</td>
              <td class="text-right">{{ element.rate |indianCurrency}}</td>
              <td class="text-right">{{ element.total |indianCurrency}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- IPD Grouped Tables -->
      <ng-container *ngIf="isIPDBill">
        <div class="print-table-wrapper mb-3" *ngFor="let group of groupedBillDetails">
          <h3 class="bg-light p-2 border border-bottom-0 m-0 f-s-16">{{ group.category }}</h3>
          <table class="table table-bordered m-0">
            <thead>
              <tr class="bg-light">
                <th class="text-left" style="width: 5%;">{{ 'LABEL.NO' |translate}}.</th>
                <th class="text-left" style="width: 45%;">Particulars</th>
                <th class="text-left" style="width: 10%;">{{ 'LABEL.QTY' |translate}}</th>
                <th class="text-right" style="width: 20%;">{{ 'LABEL.RATE' |translate}}</th>
                <th class="text-right" style="width: 20%;">{{ 'LABEL.AMOUNT' |translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of group.items; let i = index">
                <td>{{ i + 1 }}</td>
                <td class="text-left">{{ element.chargeName }}</td>
                <td class="text-left">{{ element.quantity }}</td>
                <td class="text-right">{{ element.rate |indianCurrency}}</td>
                <td class="text-right">{{ (element.total || element.totalCharge) |indianCurrency}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bg-light font-weight-bold">
                <td colspan="4" class="text-right">{{ 'LABEL.SUB_TOTAL' | translate }}</td>
                <td class="text-right">{{ group.subTotal | indianCurrency }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </ng-container>

      <hr>
      <!-- <mat-divider></mat-divider> -->
      <div class="no-break-section">
        <div class="text-right ">
          <p><strong>{{ 'LABEL.SUB_TOTAL' |translate}}:</strong> {{ billData?.subTotal |indianCurrency}}</p>
          <p>
            <strong>
              {{ 'LABEL.DISCOUNT' | translate }} ({{ discountSymbol }}):
            </strong>
            {{ billData?.discount }}
          </p>
          <h3><strong>{{ 'LABEL.TOTAL' |translate}}:</strong> {{ billData?.grandTotal |indianCurrency}}</h3>
        </div>
      </div>
      <br>
      <br>
      <div class="text-sm text-right">
        <p><strong>{{ doctorInfo?.name }}</strong></p>
        <p>{{ doctorInfo?.degree }}</p>
        <p>{{ doctorInfo?.specialityName }}</p>
        <p>{{ 'LABEL.REG_NO' |translate}}: {{ hospitalInfo?.registrationNumber }}</p>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<footer class="footer-print">
  <div class="text-center text-xs">
    <p>{{ hospitalInfo?.name }}</p>
    <p>{{ hospitalInfo?.address }}, {{ hospitalInfo?.city }}</p>
    <p>
      {{ 'LABEL.PHONE_LABEL' |translate}}: {{ hospitalInfo?.mobile }} |
      {{ 'LABEL.EMAIL_LABEL' |translate}}:
      <a href="mailto:{{ hospitalInfo?.email }}" class="text-blue-600 underline">
        {{ hospitalInfo?.email }}
      </a>
    </p>
  </div>
</footer>